export default __webpack_public_path__ + "static/media/helm_of_vicious_frenzy.ce4efb8e.jpg";